import { UserDto } from '~modules/user/model';
import { ApplyBtn } from '~shared/ui/button/apply-btn';
import { InputItem } from '~shared/ui/input-item/input-item';

import { UserSelect } from '../user-select/user-select';

interface AddRoleItemProps {
	user: UserDto | null;
	name: string;
	isOpen?: boolean;
	onChange: (data: { user: UserDto | null; name: string }) => void;
	onAccept: () => void;
	onCancel: () => void;
}

export function AddRoleItem({ name, user, onChange, onAccept }: AddRoleItemProps) {
	return (
		<tr className="role-item">
			<td className="role-item__user">
				<UserSelect
					value={user ? [user] : []}
					className="user-container"
					selectClassName="user-select"
					onChange={v => {
						if (!Array.isArray(v)) {
							onChange({ user: v, name });
						}
					}}
				/>
			</td>
			<td className="role-item__name">
				<InputItem
					placeholder="Введите роль"
					value={name}
					onChange={e => onChange({ name: e.target.value, user })}
				/>
			</td>
			<td className="role-item__actions">
				<ApplyBtn onClick={onAccept} />
			</td>
		</tr>
	);
}
